import { createContext, useContext } from 'react';

import type { MfaIntent, Session } from '../domain/entities/session';

export interface AuthStateValue {
  session: Session | null;
  isAuthenticated: boolean;
  mfaIntent: MfaIntent | null;
  sessionExpired: boolean;
  sessionExpiredReason: 'organization_suspended' | null;
  setSession: (session: Session | null) => void;
  setMfaIntent: (intent: MfaIntent | null) => void;
  clearSessionExpired: () => void;
  expireSession: () => Promise<void>;
  signOut: () => Promise<void>;
  getSession: () => Session | null;
  getMfaIntent: () => MfaIntent | null;
}

export const AuthStateContext = createContext<AuthStateValue | null>(null);

export function useAuthState(): AuthStateValue {
  const state = useContext(AuthStateContext);
  if (!state) throw new Error('AuthStateProvider is missing');
  return state;
}
